import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import { Tab, Tabs } from 'material-ui/Tabs'
import Snackbar from 'material-ui/Snackbar'
import { FormattedMessage } from 'react-intl'
import { isAccountFree, isAccountPremium, isAccountStartter } from '../../lib'
import ProfilePic from '../../components/ProfilePic'
import SettingsForm from '../../components/SettingsForm'
import PlanDetails from '../../components/PlanDetails'
import Upload from '../../components/Upload'

class AdminSettings extends Component {
  state = {
    snackbarOpen: false,
    snackbarEmailChange: false,
    index_0: '#29B87A',
    index_1: '#afb8c5'
  }

  componentWillReceiveProps = props => {
    if (props.emailChange) {
      this.setState({snackbarOpen: true})
      this.setState({snackbarEmailChange: true})
      props.closeSnackbar()
    }
  }

  handleTabChange = e => {
    const index = e.props.index
    switch (index) {
      case 0:
        this.setState({index_0: '#29B87A', index_1: '#afb8c5'})
        break
      case 1:
        this.setState({index_1: '#29B87A', index_0: '#afb8c5'})
        break
      default:
        console.error('out of context')
    }
  }

  handleRequestClose = () => {
    this.setState({snackbarOpen: false})
  }

  handleRequestOpen = () => this.setState({snackbarOpen: true})

  render () {
    const storageInfo = (this.props.storageInfo / (1000 * 1000)).toFixed(2)
    return (
      <div className="h-100 w-100 flex items-center pt3 pr6 justify-center">
        <Paper
          rounded={false}
          style={{
            width: 544,
            backgroundColor: '#FAFAFA',
            height:
              this.props.showWebcam || this.props.showUploadOtion ? 590 : '100%'
          }}
        >
          {this.props.showWebcam ? (
            <Upload
              returnUserIfUserExists={this.props.returnUserIfUserExists}
              userid={this.props.userid}
              handleRequestOpen={this.handleRequestOpen}
              webcam
              takePicture={this.props.takePicture}
            />
          ) : this.props.showUploadOtion ? (
            <Upload
              returnUserIfUserExists={this.props.returnUserIfUserExists}
              userid={this.props.userid}
              handleRequestOpen={this.handleRequestOpen}
              takePicture={this.props.uploadPicture}
            />
          ) : (
            <Tabs
              contentContainerClassName={`pt3 pb3
                ${this.props.showWebcam ||
              this.props.showUploadOtion ||
              this.state.index_1 === '#29B87A'
                ? 'pl3 pr3'
                : 'pl5 pr5'}`}
              inkBarStyle={{background: '#29B87A', height: 3}}
              tabItemContainerStyle={{
                backgroundColor: '#FFFFFF',
                color: '#29B87A',
                borderBottom: '1px solid #d9d9d9',
                boxShadow: '0 8px 3px -5px #d9d9d9'
              }}
            >
              <Tab
                onActive={this.handleTabChange}
                buttonStyle={{color: this.state.index_0}}
                label={<FormattedMessage id="settings.account"/>}
              >
                <div className="h-100 w-100">
                  <ProfilePic
                    height="20%"
                    userid={this.props.userid}
                    uploadPicture={this.props.uploadPicture}
                    takePicture={this.props.takePicture}
                  />
                  <div style={{height: '80%'}}>
                    <SettingsForm {...this.props} />
                  </div>
                </div>
              </Tab>

              <Tab
                onActive={this.handleTabChange}
                buttonStyle={{color: this.state.index_1}}
                label={<FormattedMessage id="settings.billing"/>}
              >
                <PlanDetails
                  location={this.props.location.pathname}
                  concurrentSeminars={1}
                  seminarsPerMonth={
                    isAccountFree(this.props.accountType) ? (
                      3
                    ) : (
                      <FormattedMessage id="settings.unlimited"/>
                    )
                  }
                  maxParticipants={
                    isAccountPremium(this.props.accountType) ? 30 : 10
                  }
                  recordingStorage={
                    isAccountStartter(this.props.accountType)
                      ? `${storageInfo}GB / 10GB`
                      : isAccountPremium(this.props.accountType)
                      ? `${storageInfo}GB / 30GB`
                      : null
                  }
                  plan={this.props.accountType}
                />
              </Tab>
            </Tabs>
          )}
        </Paper>
        {false && <Snackbar
          style={{left: 200, bottom: 30}}
          open={this.state.snackbarOpen}
          message={
            this.state.snackbarEmailChange ? (
              <FormattedMessage id="settings.updateEmail"/>
            ) : (
              <FormattedMessage id="settings.picMessage"/>
            )
          }
          action={<FormattedMessage id="seminarActions.dismiss"/>}
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />}
      </div>
    )
  }
}

export default AdminSettings



// WEBPACK FOOTER //
// ./src/routes/Settings/AdminSettings.js